import Vue from "vue";
import VueRouter from "vue-router";

import Index from "../view/Index.vue";
import Team from "../components/Team.vue";
import Introduction from "@/components/child/Introduction";
import JoinUs from "@/components/child/JoinUs";
import ConactUs from "@/components/child/ConactUs";
import Academic from "@/components/Academic";
import Book from "@/components/child/Book";
import Paper from "@/components/child/Paper";
import Patent from "@/components/child/Patent";
import Software from "@/components/child/Software";
import Projects from "@/components/Projects";
import ComntStudent from "@/components/Comnt&Student";
import Scientific from "@/components/Scientific";
 import UAV_system from "@/components/achievement/UAV_system";
 import UAV_auto from "@/components/achievement/UAV_auto";
 import LuojiaSwarm from "@/components/achievement/LuojiaSwarm";
 import Target_retrieval from "@/components/achievement/Target_retrieval";
import Element_extraction from "@/components/achievement/Element_extraction";
import RS_changeDetection from "@/components/achievement/RS_changeDetection";
import Field_portable_system from "@/components/achievement/Field_portable_system";
import Onboard_system from "@/components/achievement/Onboard_system";
import UAV from "@/components/achievement/UAV";
import Aircraft_Systems from "@/components/achievement/Aircraft_Systems";
import vehicle_vision_system from "@/components/achievement/vehicle_vision_system";
import Big_data from "@/components/achievement/Big_data";
import d3_GIS from "@/components/achievement/d3_GIS";
import Illegal_building from "@/components/achievement/Illegal_building";
import Resource_updata from "@/components/achievement/Resource_updata";
import Disaster_apply from "@/components/achievement/Disaster_apply";
import Emergency_apply from "@/components/achievement/Emergency_apply";
import Resource_apply from "@/components/achievement/Resource_apply";
import NLP from "@/components/achievement/NLP";
import Biodiversity from "@/components/achievement/Biodiversity";
import Smart_city from "@/components/achievement/Smart_city";
import Communication from "@/components/child/Communication";
import Award from "@/components/child/Award";
import Dataset from "../components/child/Dataset";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    name: "Index",
    component: Index
  },
  {
    path: "/team",
    name: "Team",
    component: Team,
    redirect: "/team/introduction",
    children: [
      {
        path: "/team/introduction",
        name: "Introduction",
        component: Introduction
      },
      {
        path: "/team/joinus",
        name: "JoinUs",
        component: JoinUs
      },
      {
        path: "/team/conactus",
        name: "ConactUs",
        component: ConactUs
      }
    ]
  },
  {
    path: "/academic",
    name: "Academic",
    component: Academic,
    redirect: "/academic/book",
    children: [
      {
        path: "/academic/book",
        name: "Book",
        component: Book
      },
      {
        path: "/academic/paper",
        name: "Paper",
        component: Paper
      },
      {
        path: "/academic/patent",
        name: "Patent",
        component: Patent
      },
      {
        path: "/academic/software",
        name: "Software",
        component: Software
      },
      {
        path: "/academic/projects",
        name: "Projects",
        component: Projects
      }
    ]
  },
  {
    path: "/conact",
    name: "JoinUs",
    component: JoinUs
  },
  {
    path: "/comnt&student",
    name: "ComntStudent",
    component: ComntStudent,
    redirect: "/comnt&student/academic",
    children: [
      {
        path: "/comnt&student/academic",
        component: Communication,
      },
      {
        path: "/comnt&student/awards",
        component: Award,
      },
      {
        path: "/comnt&student/RS_changeDetection",
        component: RS_changeDetection,
      }
    ]
  },
  {
    path: "/scientific",
    name: "Scientific",
    component: Scientific,
    redirect: "/scientific/Target_retrieval",
    children: [
      {
        path: "/scientific/UAV_system",
        component: UAV_system,
      },
      {
        path: "/scientific/UAV_auto",
        component: UAV_auto,
      },
      {
        path: "/scientific/LuojiaSwarm",
        component: LuojiaSwarm,
      },
      {
        path: "/scientific/Target_retrieval",
        component: Target_retrieval,
      },

      {
        path: "/scientific/Element_extraction",
        component: Element_extraction,
      },
      {
        path: "/scientific/RS_changeDetection",
        component: RS_changeDetection,
      },
      {
        path: "/scientific/Field_portable_system",
        component: Field_portable_system,
      },
      {
        path: "/scientific/Onboard_system",
        component: Onboard_system,
      },
      {
        path: "/scientific/UAV",
        component: UAV,
      },
      {
        path: "/scientific/Aircraft_Systems",
        component: Aircraft_Systems,
      },
      {
        path: "/scientific/vehicle_vision_system",
        component: vehicle_vision_system,
      },
      {
        path: "/scientific/Big_data",
        component: Big_data,
      },
      {
        path: "/scientific/d3_GIS",
        component: d3_GIS,
      },
      {
        path: "/scientific/Illegal_building",
        component: Illegal_building,
      },
      {
        path: "/scientific/Resource_updata",
        component: Resource_updata,
      },
      {
        path: "/scientific/Disaster_apply",
        component: Disaster_apply,
      },
      {
        path: "/scientific/Emergency_apply",
        component: Emergency_apply,
      },
      {
        path: "/scientific/Resource_apply",
        component: Resource_apply,
      },
      {
        path: "/scientific/NLP",
        component: NLP,
      },
      {
        path: "/scientific/Biodiversity",
        component: Biodiversity,
      },
      {
        path: "/scientific/Smart_city",
        component: Smart_city,
      },
    ]
  },
  {
    path: "/dataset",
    name: "Dataset",
    component: Dataset
  },
];

// 如果当前路由地址不变，跳过
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: "/suihaigang",
  routes,
});

export default router;
